import "./icon.style.scss";

export default function IconFile({extencion}:{extencion:string}){
  return (
    <div className="icon-file">
      <div className="icon-file-p1"></div>
      <div className="icon-file-p2"></div>
      <div className="icon-file-text">{extencion.toLocaleLowerCase()}</div>
    </div>
  );
}